export default __webpack_public_path__ + "assets/partly-cloudy-day-rain.4c0668cc.svg";